import React from 'react'
import ImagesPallet from '../../../../utils/ImagesPallet'

import { ArrowUpRight } from 'lucide-react'

function AboutSection() {
  return (
    <div className="container mx-auto px-6 pt-24 mb-10">
     <div className="flex flex-col lg:flex-row gap-12 items-start">
       {/* Left Content */}
       <div className="lg:w-1/2 pt-8">
         <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">
          THE BIGGEST LUXURIOUS BARBERSHOP IN INDONESIA
         </h1>
         <p className="text-black text-lg mb-8">
           Papakilo barbershop adalah tempat cukur rambut mewah terbesar di Indonesia. Sejak didirikan pada tahun 2023, Papakilo Barbershop telah berkembang menjadi 3 cabang di Jakarta dan Medan. Pada tahun 2025 kami berencana untuk memperluas cabang kami.
         </p>
         {/* <div className="flex flex-wrap gap-4">
            <a href='/story-hairstudio'>
              <button  className="px-8 py-3 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold hover:opacity-90 transform hover:scale-110 ease-in duration-300">
              Selengkapnya 
                <ArrowUpRight className='inline ml-2'/>
              </button>
           </a>
         </div> */}
         
         {/* Informations */}
          <div className="grid grid-cols-3 gap-4 mt-8 pointer-events-auto">
            {/* Total Pelanggan */}
           <div className="grid grid-rows-3 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300">
             <img className='transform scale-150'
               src={ImagesPallet.BarberChair}/>
             <h1 className='text-2xl md:text-5xl font-bold mb-6 bg-clip-text'>6.6K+</h1>
             <h1 className='md:text-lg font-semibold'>Total Pelanggan</h1>
           </div>

          {/* Total Capster Profesional */}
           <div className="grid grid-rows-3 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300">
             <img className='w-16'
               src={ImagesPallet.Stylish}/>
              <h1 className='text-2xl md:text-5xl font-bold mb-6 bg-clip-text'>50+</h1>
              <h1 className='md:text-lg font-semibold'>Total Kapster</h1>
           </div>
            
            {/* Style Hair Yang Sudah Dibuat */}
           <div className="grid grid-rows-3 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300">
             <img className='w-12'
               src={ImagesPallet.BarberStylish}/>
              <h1 className='text-2xl md:text-5xl font-bold mb-6 bg-clip-text'>150+</h1>
              <h1 className='text-xl md:text-lg font-semibold'>Gaya Rambut</h1>
           </div>
         </div>

       </div>

       {/* Right Image Grid */}
       <div className="lg:w-1/2">
         <div className="grid grid-cols-2 gap-4">
           {/* Main large image */}
           <div className="col-span-2 transform hover:scale-110 ease-in duration-300">
             <img
               src={ImagesPallet.HeroSectionAbout1}
               alt="Barber Service"
               className="w-full h-64 object-cover rounded-lg"
             />
           </div>
           
           {/* Tools image */}
           <div className='transform hover:scale-110 ease-in duration-300'>
             <img
               src={ImagesPallet.HeroSectionAbout2}
               alt="Hair Tools"
               className="w-full h-48 object-cover rounded-lg"
             />
           </div>
           
           {/* Chair image */}
           <div className='transform hover:scale-110 ease-in duration-300'>
             <img
               src={ImagesPallet.HeroSectionAbout3}
               alt="Barber Robot"
               className="w-full h-48 object-cover rounded-lg"
             />
           </div>
           
           {/* Bottom image */}
           <div className="col-span-2 transform hover:scale-105 ease-in duration-300">
             <img
               src={ImagesPallet.HeroSectionAbout4}
               alt="Hair Washing"
               className="w-full h-48 object-cover rounded-lg"
             />
           </div>
         </div>
       </div>
     </div>
   </div>
  )
}

export default AboutSection